import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Help } from 'app/shared/models/class/help/help';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  private baseUrl: string = environment.apiUrl + '/Report';

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getReport(keyWord: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${keyWord}`, { observe: 'response', responseType: 'blob' })
      .pipe(map(res => this.saveFile(res)));
  }

  getReportSession(sessionkey: number): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/SessionPlanning/${sessionkey}`, { observe: 'response', responseType: 'blob' })
      .pipe(map(res => this.saveFile(res)));
  }

  getPayementsCounter(clubCode: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/PaymentsCounter/${clubCode}`, { observe: 'response', responseType: 'blob' })
      .pipe(map(res => this.saveFile(res)));
  }


  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */


  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */


  private saveFile(res: HttpResponse<Blob>): Blob {
    FileSaver.saveAs(res.body, res.headers.get('filename'));
    return res.body;
  }
}
